<template>
  <div >

      <div class="container">


            <section class="pt-5">

                <!-- Heading & Description -->
                <div class="wow fadeIn">
                    <!--Section heading-->
                    <h2 class="h1 text-center mb-5">Personal Signer Help</h2>
                    <!--Section description-->
                    <p class="text-center">Personal Signer is the app you need for signing anywhere using your own digital certifcates. </p>
                    <p class="text-center mb-5 pb-5">You can find here some video guides  explaining how to work with Personal Signer
                        & tutorials.</p>
                </div>
                <!-- Heading & Description -->

                <!--Grid row-->
        <div class="row wow fadeIn">

                    <!--Grid column-->
                    <div class="col-lg-5 col-xl-4 mb-4">
                        <!--Featured image-->
                        <div class="view overlay rounded z-depth-1-half">
                            <div class="view overlay">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/lXfj99QsiAs?rel=0" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Grid column-->

                    <!--Grid column-->
                    <div class="col-lg-7 col-xl-7 ml-xl-4 mb-4">
                        <h3 class="mb-3 font-weight-bold dark-grey-text">
                            <strong>Init certificates store and adding a certificate</strong>
                        </h3>
                        <p class="grey-text">Get started with Personal Signer, initiaize the certificates store setting a password and then add a certificate browsing the files in your device.</p>
                        <p>
                            <strong>You need to do this only when you want to add add a certificate.</strong>
                        </p>
 
                    </div>
                    <!--Grid column-->

                </div>

                <hr class="mb-5">



                <div class="row wow fadeIn">

                    <!--Grid column-->
                    <div class="col-lg-5 col-xl-4 mb-4">
                        <!--Featured image-->
                        <div class="view overlay rounded z-depth-1-half">
                            <div class="view overlay">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/nD9hgeSHtiI?rel=0" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Grid column-->

                    <!--Grid column-->
                    <div class="col-lg-7 col-xl-7 ml-xl-4 mb-4">
                        <h3 class="mb-3 font-weight-bold dark-grey-text">
                            <strong>Adding Certificates - Browsing</strong>
                        </h3>
                        <p class="grey-text">Add a certificate browsing the files in your device. Remember that you need tto have your certificate inside a zip file.</p>
                        <p>
                            <strong>You need to do this only when you want to add add a certificate.</strong>
                        </p>

                    </div>
                    <!--Grid column-->

                </div>
                <!--Grid row-->

                <hr class="mb-5">


                <div class="row wow fadeIn">

                    <!--Grid column-->
                    <div class="col-lg-5 col-xl-4 mb-4">
                        <!--Featured image-->
                        <div class="view overlay rounded z-depth-1-half">
                            <div class="view overlay">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/Nuo9N0sqO1Y?rel=0" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Grid column-->

                    <!--Grid column-->
                    <div class="col-lg-7 col-xl-7 ml-xl-4 mb-4">
                        <h3 class="mb-3 font-weight-bold dark-grey-text">
                            <strong>Adding Certificates. Share from other app</strong>
                        </h3>
                        <p class="grey-text">You can also add a certificate sharing a ZIP file containing your certificate from other app</p>
                        <p>
                            <strong>5You need to do this only when you want to add add a certificate.</strong>
                        </p>
 
                    </div>
                    <!--Grid column-->

                </div>
                <hr class="mb-5">

              <div class="row wow fadeIn">

                    <!--Grid column-->
                    <div class="col-lg-5 col-xl-4 mb-4">
                        <!--Featured image-->
                        <div class="view overlay rounded z-depth-1-half">
                            <div class="view overlay">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/7QWmjEG8WGY?rel=0" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Grid column-->

                    <!--Grid column-->
                    <div class="col-lg-7 col-xl-7 ml-xl-4 mb-4">
                        <h3 class="mb-3 font-weight-bold dark-grey-text">
                            <strong>Sign a document</strong>
                        </h3>
                        <p class="grey-text">Once you have a certificate in your store you can sign any PDF files in your device or from external URLs in an easy way.</p>
                        <p>
                            <strong>You can set a number of options for signing, go to Settings section.</strong>
                        </p>
 
                    </div>
                    <!--Grid column-->

                </div>

                <!--Grid row-->

                <!--Grid row-->

                <hr class="mb-5">
             


                <!--Pagination-->
           
                <!--Pagination-->

            </section>
            <!--Section: Cards-->

        </div> 
 
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to zzzzzzxxxxxz MDB Vue.js App'
    };
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  font-weight: normal;
  padding-top: 20px;
  padding-bottom: 30px;
}
p {
  color: #969696;
  margin-bottom: 0;
  font-size: 14px;
}
</style>
